import { gql, useMutation } from '@apollo/client'

const REFUND_PAYMENT = gql`
  mutation PaymentRefund($paymentId: ID!, $cartItemId: ID) {
    paymentRefund(input: { paymentId: $paymentId, cartItemId: $cartItemId }) {
      message
      status
    }
  }
`

export const useRefundPayment = () => {
  const [refundPayment, { loading, error }] = useMutation(REFUND_PAYMENT)

  // HET-3540: cartItemId presente = estorno de UM item da venda decomposta (order bump)
  const handleRefund = async (paymentId: string, cartItemId?: string) => {
    const response = await refundPayment({
      variables: { paymentId, cartItemId },
    })

    return response.data.paymentRefund
  }

  return { handleRefund, loading, error }
}

// HET-3810: o aluno gera um novo pix/boleto para um pagamento vencido. Mesma
// tubulação do reembolso: mutation no core → sparkecommerce (buyer_api) → sparkpay.
const REACTIVATE_PAYMENT = gql`
  mutation PaymentReactivate($paymentId: ID!) {
    paymentReactivate(input: { paymentId: $paymentId }) {
      message
      status
    }
  }
`

export const useReactivatePayment = () => {
  const [reactivatePayment, { loading, error }] =
    useMutation(REACTIVATE_PAYMENT)

  const handleReactivate = async (paymentId: number | string) => {
    const response = await reactivatePayment({
      variables: { paymentId: String(paymentId) },
    })

    return response.data.paymentReactivate
  }

  return { handleReactivate, loading, error }
}
